module.exports = __webpack_public_path__ + "img/coins.481f4465.png";